@for (item of vaps; track item; let i = $index) {
  <div class="addon-expander addon-expander--checkbox">
    <div class="addon-expander__header">
      <label class="custom-input custom-input--checkbox">
        <input type="checkbox"
          [checked]="item?.checked"
          (click)="checkAddon(i)"
          [id]="'checkbox' + currentVap?.product_vaps_id + '-' + item?.session_item_id"
          [class]="'addon-' + currentVap?.product_vaps_id"/>
          <span class="custom-input__indi"></span>
        </label>
        <a [href]="'#addon-vehicle-field-' + item?.session_item_id"
          class="addon-expander__title"
          [ngClass]="{'collapsed': !item?.show}"
          data-toggle="collapse"
          style="cursor:default"
          (click)="$event.preventDefault()"
          aria-expanded="false">
          <h6>{{item?.description?.length ? item?.description[2] : ''}}</h6>
          <div class="addon-expander__cost" [ngClass]="{'is-active': item?.is_active}">
            <p>
              <strong [class]="currentVap?.product_vaps_id + '-' + item?.session_item_id + '-price addon-price-' + currentVap?.product_vaps_id + ' addon-' + currentVap?.product_vaps_id">
              {{item?.price | currency:'ZAR':'R ':'1.0-0'}}</strong> /mo
            </p>
          </div>
          <div class="addon-expander__caret">
            <svg class="icon">
              <use xlink:href="#dropdown"></use>
            </svg>
          </div>
        </a>
      </div>
      <div class="addon-expander__content collapse"
        [ngClass]="{'show': item?.show}"
        [id]="'addon-vehicle-field-' + item?.session_item_id">
        <div class="modal-addons__item">
          <div class="form-group">
            <label [for]="question?.cent_aq_question_id">{{question?.question_copy}}</label>
            <input
              currencyMask
              type="text"
              [(ngModel)]="item.value"
              (ngModelChange)="onChange(i, 0)"
              [class]="'form-control answers ' + question?.cent_aq_question_id"
                [placeholder]="(question?.min_val | currency : 'ZAR' : 'R ' : '0.0-0') + ' - ' +
                (question?.max_val | currency : 'ZAR' : 'R ' : '1.0-0')"
              [options]="maskOptions" />
            </div>
          </div>
        </div>
      </div>
    }
